import React from 'react'
import { Modal, Button } from 'react-bootstrap'
const { Header, Body, Footer } = Modal;

const M = ({children, opened, hideModal, submitModal, submitLabel, showCancel, title, submitDisabled, danger}) => {
  return(
    <div>
      <Modal
        show={ opened }
        onHide={ hideModal }
      >
        <Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Header>
        <Body>
          {React.isValidElement(children) ?
            React.cloneElement(children
          ) : null}
        </Body>
        <Footer>
          {showCancel && <Button bsStyle="default" onClick={ hideModal }>Cancel</Button>}
          <Button bsStyle={danger?'danger':'primary'} 
            onClick={ submitModal } disabled={submitDisabled}>
            {submitLabel || 'Done'}
          </Button>
        </Footer>
      </Modal>
    </div>
  )
}

export default M



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Modal.js